import { Children, cloneElement, useState } from 'react'
import { AccordionProps } from './Accordion.types'
import { AccordionContent } from './subcomponents/AccordionContent/AccordionContent'
import { AccordionHeader } from './subcomponents/AccordionHeader/AccordionHeader'
import { AccordionItem } from './subcomponents/AccordionItem/AccordionItem'
import { AccordionContext } from './utils/accordionContext'
import Box from 'components/shared/Box'

export const Accordion = ({
    value,
    children,
    isAutoScrolling,
    'data-testid': testId,
}: AccordionProps) => {
    const [expandedItemId, setExpandedItemId] = useState<string | null>(
        value || null
    )
    const [shouldAutoScroll, setShouldAutoScroll] = useState<boolean>(false)

    const toggleAccordion = (id: string) => {
        setExpandedItemId((prevId) => (prevId === id ? null : id))
        isAutoScrolling && setShouldAutoScroll(true)
    }

    const managedChildren = Children.map(children, (child, index) =>
        cloneElement(child, {
            'data-testid': testId ? `${testId}-${index}` : undefined,
            isAutoScrolling: shouldAutoScroll,
        })
    )

    return (
        <AccordionContext.Provider value={{ expandedItemId, toggleAccordion }}>
            <Box width="100%" direction="column" data-component="Accordion">
                {managedChildren}
            </Box>
        </AccordionContext.Provider>
    )
}

Accordion.Item = AccordionItem
Accordion.Header = AccordionHeader
Accordion.Content = AccordionContent
